let defaultState = {
    SelectedIndex: 0,
    List: [
        {
            CustomerGuid: "5A013042-88A2-4872-9A72-AAC1BDF4B07E",
            LogoSrc: "://via.placeholder.com/100",
            Colour: "#d0102c",
            ShowPricing: false,
            Type: "DGN"
        },
        {
            CustomerGuid: "08041712-3caf-4438-b444-f08aa23fde57",
            LogoSrc: "://via.placeholder.com/100",
            Colour: "#4ae291",
            ShowPricing: false,
            Type: "TruFrame"
        },
        {
            CustomerGuid: "C7F13F21-8A45-46C5-AB5C-6B92FDABF67C",
            LogoSrc: "://via.placeholder.com/100",
            Colour: "#159761",
            ShowPricing: false,
            Type: "Other"
        },
        {
            CustomerGuid: "71E68D39-2AE7-42A2-8273-03A2CCA481B0",
            LogoSrc: "://via.placeholder.com/100",
            Colour: "#981462",
            ShowPricing: true,
            Type: "Other"
        }
    ]
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case "LOAD_CUSTOMER_GUID":
            var selectedIndex = state.SelectedIndex;
            for (var index in state.List) {
                if (state.List[index].CustomerGuid.toLowerCase() === action.payload.customerGuid.toLowerCase()) selectedIndex = index;
            }
            return { ...state, SelectedIndex: selectedIndex };
        case "LOAD_DGN_GUID":
            return { ...state, SelectedIndex: 0 };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/customers_reducer.js